const items = [
    { image: "/mainImages/LSR-Aware-PC.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/LSRAWARE_v2.27RC_WebGL_VAPI_rappoFix/LSRAWARE_v2.27RC_WebGL_VAPI_rappoFix/index.html" },
    { image: "/mainImages/LSR-Pro-PC.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/LSRPRO_v4.70RC_WebGL_VAPI_rappoFix/LSRPRO_v4.70RC_WebGL_VAPI_rappoFix/index.html" },
    { image: "/mainImages/LSR-Roads-PC.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/LSRDD_v4.70RC_WebGL_VAPI_rappoFix/LSRDD_v4.70RC_WebGL_VAPI_rappoFix/index.html" },
    { image: "/mainImages/Driving-Aware-All-Roads-PC.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/VSRSTAware_v2.27RC_WebGL_VAPI_rappoFix/VSRSTAware_v2.27RC_WebGL_VAPI_rappoFix/index.html"},
    { image: "/mainImages/DrivingPro-Black-Top-PC.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/VSRSTBlackTop_v4.70RC_WebGL_VAPI_rappoFix/VSRSTBlackTop_v4.70RC_WebGL_VAPI_rappoFix/index.html" },
    { image: "/mainImages/DrivingPro-Graded-Road-PC.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/VSRSTGraded_v4.70RC_WebGL_VAPI_rappoFix/index.html" },
    { image: "/bundleimages/processsafetylockout.png", url: "https://webglaccessrestricted.s3.me-south-1.amazonaws.com/OCIProcessSafety_v4.70RC_WebGL_VAPI_rappoFix/OCIProcessSafety_v4.70RC_WebGL_VAPI_rappoFix/index.html" }
  ];
  // comment for git
  const GamePlay = () => {
    return (
      <div className="gameplay-section">
        <p className="module-title"> Play Game</p>
        <div className="play-gap">
          <div className="checkout-container-business">
            {items.map((item, index) => {
              const fileName = item.image.split("/").pop().split(".")[0];
              return (
                <div key={index} className="item">
                  {item.url ? (
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      <img src={item.image} alt={fileName} />
                      <div className="description-box-play" id="color-change">Play Game</div>
                    </a>
                  ) : (
                    <div>
                      <img src={item.image} alt={fileName} />
                      <div className="description-box-play" id="color-change">No Link Available</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  
  export default GamePlay;
  